import { baseSplitApi } from "../baseApi";

const birthdayPath = '/attendance/birthdays'

export const birthdayApi = baseSplitApi.injectEndpoints({
    endpoints: (build) => ({
        getBirthdays: build.mutation({
            query: () => {
                return {
                    url: birthdayPath,
                    method: 'POST',
                    body: {
                        currentDate: new Date()
                    }
                }
            },
            transformResponse: (response)=>{
                return response.birthdays
            }
        }),
    }),
    overrideExisting: false,
}
);


export const { useGetBirthdaysMutation } = birthdayApi;